import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { categoriesData } from '../data/companyData';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/button';

const ProductsServicesPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="products-services-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#001582] to-[#001ea7] relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#FFC107] rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-[#FFC107] rounded-full" />
              <span className="text-white text-sm font-semibold uppercase tracking-wider">Katalog</span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Produk & <span className="text-[#FFC107]">Layanan</span>
            </h1>
            <p className="text-slate-300 text-lg leading-relaxed">
              Berbagai equipment industri, komponen presisi, dan layanan lengkap untuk 
              mendukung operasional industri Anda.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Categories Grid */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-slate-500 mb-8"
          >
            Menampilkan <span className="font-semibold text-[#001582]">{categoriesData.length}</span> kategori produk & layanan
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categoriesData.map((category, index) => (
              <motion.div
                key={category.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="group"
              >
                <Link to={`/produk-layanan/${category.id}`} data-testid={`category-card-${category.id}`}>
                  <div className="bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden h-full flex flex-col">
                    {/* Image */}
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img 
                        src={category.image}
                        alt={category.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#001582]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                        <span className="text-white font-medium text-sm">Lihat {category.items.length} Item</span>
                      </div>
                      {/* Item Count Badge */}
                      <div className="absolute top-4 right-4">
                        <span className="px-3 py-1.5 bg-[#FFC107] text-[#001582] text-xs font-bold rounded-full">
                          {category.items.length} Item
                        </span>
                      </div>
                    </div>
                    
                    {/* Content */}
                    <div className="p-6 flex-1 flex flex-col">
                      <h3 className="font-heading text-xl font-bold text-[#1a1a1a] mb-3 group-hover:text-[#001582] transition-colors">
                        {category.title}
                      </h3>
                      <p className="text-slate-600 text-sm leading-relaxed mb-4 flex-1 line-clamp-3">
                        {category.description}
                      </p>
                      
                      <Button 
                        variant="outline"
                        className="w-full border-[#001582] text-[#001582] hover:bg-[#001582] hover:text-white rounded-xl"
                      >
                        Lihat Kategori
                        <ArrowRight className="ml-2 w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#f5f7fb]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#1a1a1a] mb-4">
            Tidak menemukan yang Anda cari?
          </h3>
          <p className="text-slate-600 mb-8">
            Hubungi kami untuk kebutuhan custom sesuai spesifikasi Anda.
          </p>
          <a 
            href="https://wa.me/6285210005588" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button 
              size="lg"
              className="bg-gradient-to-r from-[#001582] to-[#001ea7] text-white hover:from-[#001ea7] hover:to-[#001582] font-semibold px-8 py-6 rounded-xl"
              data-testid="cta-whatsapp"
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Konsultasi Gratis
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsServicesPage;
